import "core-js/modules/es.array.reverse.js";
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import CatalogMemberTraits from "./CatalogMemberTraits";
import mixTraits from "../mixTraits";
import primitiveTrait from "../Decorators/primitiveTrait";
let TimeVaryingTraits = (_dec = primitiveTrait({
  name: "Time label",
  description: "Time label which is shown in workbench next to date/time selector (Will default to t(\"dateTime.selectorLabel\") = \"Time:\").",
  type: "string"
}), _dec2 = primitiveTrait({
  name: "Current Time",
  description: "The current time at which to show this dataset.",
  type: "string",
  isNullable: true
}), _dec3 = primitiveTrait({
  name: "Initial Time Source",
  description: "The initial time to use if `Current Time` is not specified. Valid values are <br/>" + " * `start` - the dataset's start time <br/>" + " * `stop` - the dataset's stop time <br/>" + " * `now` - the current system time. If the system time is after `Stop Time`, `Stop Time` is used. If the system time is before `Start Time`, `Start Time` is used. <br/>" + " * `none` - do not automatically set an initial time <br/>" + " This value is ignored if `Current Time` is specified.",
  type: "string"
}), _dec4 = primitiveTrait({
  name: "Start Time",
  description: "The earliest time for which this dataset is available. This will be the start of the range shown on the timeline control.",
  type: "string"
}), _dec5 = primitiveTrait({
  name: "Stop Time",
  description: "The latest time for which this dataset is available. This will be the end of the range shown on the timeline control.",
  type: "string"
}), _dec6 = primitiveTrait({
  name: "Time Multiplier",
  description: "The multiplier to use in progressing time for this dataset. For example, `5.0` means that five seconds of dataset time will pass for each one second of real time.",
  type: "number"
}), _dec7 = primitiveTrait({
  name: "Is Paused",
  description: "True if time is currently paused for this dataset, or false if it is progressing.",
  type: "boolean"
}), _dec8 = primitiveTrait({
  name: "Date Format",
  description: "A dateformat string (using the dateformat package) used to adjust the presentation of the date in various spots in the UI for a catalog item. <br/>" + "For example, to just show the year set to 'yyyy'. Used in places like the the Workbench Item and Bottom Dock",
  type: "string"
}), _class = class TimeVaryingTraits extends mixTraits(CatalogMemberTraits) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "timeLabel", _descriptor, this);
    _initializerDefineProperty(this, "initialTimeSource", _descriptor2, this);
    _initializerDefineProperty(this, "isPaused", _descriptor3, this);
    _initializerDefineProperty(this, "dateFormat", _descriptor4, this);
  }
  get currentTime() {
    return;
  }
  get startTime() {
    return;
  }
  get stopTime() {
    return;
  }
  get multiplier() {
    return;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "timeLabel", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "currentTime", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "currentTime"), _class.prototype), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "initialTimeSource", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return "now";
  }
}), _applyDecoratedDescriptor(_class.prototype, "startTime", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "startTime"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "stopTime", [_dec5], Object.getOwnPropertyDescriptor(_class.prototype, "stopTime"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "multiplier", [_dec6], Object.getOwnPropertyDescriptor(_class.prototype, "multiplier"), _class.prototype), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "isPaused", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "dateFormat", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { TimeVaryingTraits as default };